/*
 * @Desc: 字典
 * @Author: zcc
 * @Date: 2022-11-07 10:28:52
 * @LastEditors: zhangyi zhangy.cosmo@haier.com
 * @LastEditTime: 2023-12-08 10:38:06
 */
const dic = {
  banner: {
    Baas: {
      title: 'BaaS引擎',
      sub: '卡奥斯BaaS引擎（COSMO Business Best Practice）',
      desc: '将海尔30多年来的制造知识、工艺、机理、算法等最佳实践与商业逻辑，沉淀为BaaS引擎，内含设备物联、工业大数据、工业机理模型、数字孪生体、知识图谱、工业智能、安全防护等一系列共性数智技术赋能力，并在企业数字化赋能实践过程中，持续提炼、沉淀、迭代、拓展丰富。BaaS引擎能力可以跨行业、跨领域的复制，支撑企业实现“六化”新模式转型与创新。',
      url: ''
    },
    BigData: {
      title: '天数工业大数据',
      desc: '天数工业大数据平台是一款面向企业的全场景、低门槛、开放灵活的大数据管理与分析平台，可一站式完成数据集成、数据开发、数据治理、数据分析、数据服务，实现采、存、管、用一体化， 帮助企业实现数据价值释放',
      btn: '立即体验',
      url: 'https://bigdata.s.cosmoplat.com/'
    },
    Blockchain: {
      title: '天链',
      desc: '卡奥斯云区块链服务(COSMOPlat Blockchain as a Service，CBS)，致力于打造全球领先的企业级区块链技术服务平台，为企业客户及开发者提供高效、安全、弹性、开箱即用的区块链服务，同时面对各行业领域场景，满足用户个性化需求，一站式快速交付定制',
      btn: '立即体验',
      url: 'https://cbs.cosmoplat.com'
    },
    MechanismModel: {
      title: '机理模型',
      desc: '依托卡奥斯COSMOPlat工业互联网平台，为工业机理模型提供了完善的体验托管平台，覆盖工业机理模型的全流程管理，包括模型审批，模型上架，模型展示，模型交易，等众多业务环节',
      btn: '立即体验',
      url: 'https://imm.cosmoplat.com'
    },
    IdentityResolution: {
      title: '标识解析',
      desc: '工业互联网标识解析体系为跨领域、跨行业、跨企业提供基础资源和信息互联互通能力，是整个工业互联网网络实现互联互通的关键基础设施',
      btn: '立即体验',
      url: 'https://handle.cosmoplat.com'
    },
    OpenAPI: {
      title: 'OpenAPI 平台',
      desc: '构建API生态，形成形态各异适合多场景的API服务能力，提供统一的API认证、鉴权、安全、流量管控、缓存、服务路由，协议转换、服务编排、熔断、灰度发布、监控报警等功能',
      btn: '立即体验',
      url: 'https://openapi-tenant-admin-frontend.cosmoplat.com/'
    },
    Lcode: {
      title: '天马低代码平台',
      desc: '卡奥斯天马低代码平台是一款以低代码为核心特征的工业行业数字化应用搭建平台，致力于帮助工业行业用户以低成本、短周期、高效率的方式实现工业行业各类数字化应用',
      btn: '立即体验',
      url: 'https://www.cosmoplat.com/choice?solutionId=1549236594053566465'
    },
    IntelligentVision: {
      title: '智能视觉',
      desc: '智能视觉是用机器代替人眼进行识别、跟踪和测量目标等行为，包含图像识别、物体检测、缺陷检测等项目，广泛应用于公共安全、智能工厂、智慧交通等各种场景。智能视觉平台可以帮助零算法基础的开发者快速实现智能产品的开发，提升产品的竞争力。',
      btn: '立即体验',
      url: 'https://dlops.s.cosmoplat.com/'
    },
    BI: {
      title: 'BI平台',
      desc: '商业智能分析BI（Business Intelligence）以数据可视化和分析技术为基础，通过可视化界面快速制作多种类型的数据报表，使用户能够在多类终端上对数据进行查询、分析和探索。',
      btn: '立即体验',
      url: 'https://bi-ib.s.cosmoplat.com/#/wizard/index'
    }
  },
  carousel: {
    BigData: [
      require('../assets/big-data/bd-banner0.png'),
      require('../assets/big-data/bd-banner1.png'),
      require('../assets/big-data//bd-banner2.png')
    ],
    Blockchain: [
      require('../assets/blockchain/bc0.jpg'),
      require('../assets/blockchain/bc1.jpg'),
      require('../assets/blockchain/bc2.jpg')
    ],
    MechanismModel: [
      require('../assets/mechanism-model/immbg0.png'),
      require('../assets/mechanism-model/immbg1.png'),
      require('../assets/mechanism-model/immbg2.png')
    ],
    OpenAPI: [
      require('../assets/other/OpenAPI-1.png'),
      require('../assets/other/OpenAPI-2.png'),
      require('../assets/other/OpenAPI-3.png')
    ]
  },
  now: {
    BigData: {
      url: 'https://bigdata.s.cosmoplat.com/'
    },
    Blockchain: {
      url: 'https://cbs.cosmoplat.com'
    },
    MechanismModel: {
      url: 'https://imm.cosmoplat.com'
    },
    OpenAPI: {
      url: 'https://openapi-tenant-admin-frontend.cosmoplat.com/'
    },
    IdentityResolution: {
      url: 'https://handle.cosmoplat.com'
    },
    IntelligentVision: {
      url: 'https://publicmodel.s.cosmoplat.com/'
    },
    Lcode: {
      url: 'https://www.cosmoplat.com/choice?solutionId=1549236594053566465'
    }
  },
  Baas: {
    ctInfo: { // 核心技术
      name: 'BaaS 引擎',
      icon: 'icon-baasqukuailianfuwu',
      keys: ['向上生长工业应用', '向下接入工业设备', '打通价值的创造', '传递与分享', '实现价值驱动', '价值闭环']
    },
    BaaSknowledgeGraphCharts: [ // 图表
      {
        name: '',
        itemStyle: {
          color: '#005ddd'
        },
        children: [

          {
            name: '工业物联',
            link:'https://iot.cosmoplat.com/#/wel/index',
            icon: 'icon-wulianwang',
            children: [
              {
                name: '★',
                children: [
                  {
                    name: '设备上云'
                  },
                  {
                    name: '边缘网关'
                  }
                ]
              },
              {
                name: '☆',
                children: [
                  {
                    name: '工业协议'
                  },
                  {
                    name: '数据报表'
                  }
                ]
              }
            ]
          },
          {
            name: '标识解析',
            link:'https://handle.cosmoplat.com/#/',
            target:'blank',
            icon: 'icon-biaoshilei_tiaoxingma',
            children: [
              {
                name: '★',
                children: [
                  {
                    name: '标识注册'
                  },
                  {
                    name: '一物一码'
                  }
                ]
              },
              {
                name: '☆',
                children: [
                  {
                    name: '防伪溯源'
                  },
                  {
                    name: '标识解析'
                  }
                ]
              }
            ]
          },
          {
            name: '工业视觉',
            link:'https://baas.cosmoplat.com/intelligent-vision',
            icon: 'icon-indvigongyeshijuezhineng',
            children: [
              {
                name: '★',
                children: [
                  {
                    name: '检测'
                  },
                  {
                    name: '定位'
                  }
                ]
              },
              {
                name: '☆',
                children: [
                  {
                    name: '测量'
                  },
                  {
                    name: '识别'
                  }
                ]
              }
            ]
          },
          {
            name: 'PaaS容器云',
            link:'https://it.cosmoplat.com/container/dashboard',
            icon: 'icon-paas',
            children: [
              {
                name: '★',
                children: [
                  {
                    name: '弹性伸缩'
                  },
                  {
                    name: '灵活编排'
                  }
                ]
              },
              {
                name: '☆',
                children: [
                  {
                    name: '持续集成'
                  },
                  {
                    name: '持续交付'
                  }
                ]
              }
            ]
          },
          {
            name: '工业大数据',
            link:'https://bigdata.s.cosmoplat.com/#/login',
            icon: 'icon-dashuju',
            children: [
              {
                name: '★',
                children: [
                  {
                    name: '数据汇聚'
                  },
                  {
                    name: '数据存储'
                  },
                  {
                    name: '数据治理'
                  }
                ]
              },
              {
                name: '☆',
                children: [
                  {
                    name: '数据计算'
                  },
                  {
                    name: '数据分析'
                  },
                  {
                    name: '数据可视化'
                  }
                ]
              }
            ]
          },
          {
            name: '隐私计算',
          
            icon: 'icon-yinsibaohu',
            children: [
              {
                name: '★',
                children: [
                  {
                    name: '联邦学习'
                  },
                  {
                    name: '多方安全计算'
                  },
                  {
                    name: '可信执行环境'
                  }
                ]
              },
              {
                name: '☆',
                children: [
                  {
                    name: '隐私保护'
                  },
                  {
                    name: '数据可用不可见'
                  }
                ]
              }
            ]
          },
          {
            name: '机器学习(AI)',
            link:'https://dlops.s.cosmoplat.com/login?redirect=/home/project',
            icon: 'icon-jiqiren',
            children: [
              {
                name: '★',
                children: [
                  {
                    name: '深度学习'
                  },
                  {
                    name: '视觉'
                  },
                  {
                    name: 'NLP'
                  }
                ]
              },
              {
                name: '☆',
                children: [
                  {
                    name: '语音'
                  },
                  {
                    name: '自动程序设计'
                  }
                ]
              }
            ]
          },
          {
            name: '区块链',
            link:'https://cbs.cosmoplat.com/union',
            icon: 'icon-line_qukuailian',
            children: [
              {
                name: '★',
                children: [
                  {
                    name: '安全性'
                  },
                  {
                    name: '国产化'
                  }
                ]
              },
              {
                name: '☆',
                children: [
                  {
                    name: '高性能'
                  },
                  {
                    name: '易开发'
                  }
                ]
              }
            ]
          },
          {
            name: '机理模型',
            link:'https://imm.cosmoplat.com/#/',
            icon: 'icon--_wulijilijisuan',
            children: [
              {
                name: '★',
                children: [
                  {
                    name: '研发仿真'
                  },
                  {
                    name: '数据算法'
                  }
                ]
              },
              {
                name: '☆',
                children: [

                  {
                    name: '业务流程'
                  },
                  {
                    name: '行业机理'
                  }
                ]
              }
            ]
          },

          {
            name: '知识图谱',
            icon: 'icon-zhishitupu',
            children: [
              {
                name: '★',
                children: [
                  {
                    name: '知识抽取'
                  },
                  {
                    name: '知识存储'
                  }
                ]
              },
              {
                name: '☆',
                children: [
                  {
                    name: '融合推理'
                  },
                  {
                    name: '知识检索'
                  }
                ]
              }
            ]
          },

          {
            name: '数字孪生',
            link:'https://www.cosmoplat.com/activity/d3os',
            icon: 'icon-gongnenglan-shuziluanshengren',
            children: [
              {
                name: '★',
                children: [
                  {
                    name: '建模'
                  },
                  {
                    name: '渲染'
                  },
                  {
                    name: '仿真'
                  }
                ]
              },
              {
                name: '☆',
                children: [
                  {
                    name: '控制执行'
                  },
                  {
                    name: '人机交互'
                  }
                ]
              }
            ]
          },
          {
            name: '低代码技术',
            link:'https://lcode.cosmoplat.com/#/staging',
            icon: 'icon-daima',
            children: [
              {
                name: '★',
                children: [
                  {
                    name: '业务建模'
                  },
                  {
                    name: '流程引擎'
                  }
                ]
              },
              {
                name: '☆',
                children: [
                  {
                    name: '组件定制'
                  },
                  {
                    name: '智能开发'
                  }
                ]
              }
            ]
          },
          {
            name: 'OpenAPI',
            link:'https://openapi-tenant-admin-frontend.cosmoplat.com/#/dashboard',
            icon: 'icon-daima',
            children: [
              {
                name: '★',
                children: [
                  {
                    name: '全生命周期'
                  },
                  {
                    name: '调用过程管控'
                  }
                ]
              },
              {
                name: '☆',
                children: [
                  {
                    name: '运维管理'
                  }
                ]
              }
            ]
          },
          {
            name: '工业安全',
            icon: 'icon-anquan',
            children: [
              {
                name: '★',
                children: [
                  {
                    name: '工业安全防护'
                  },
                  {
                    name: '安全态势感知'
                  }
                ]
              },
              {
                name: '☆',
                children: [
                  {
                    name: '零信任'
                  },
                  {
                    name: '数据安全防护'
                  },
                  {
                    name: '安全运营托管'
                  }
                ]
              }
            ]
          },
          {
            name: '更多',
            icon: 'icon-anquan',
            children: [
              {
                name: '★',
                children: [
                  {
                    name: '.'
                  },
                  {
                    name: '.'
                  },
                  {
                    name: '.'
                  }
                ]
              }
            ]
          }

        ]
      }

    ],
    ldList: [ //  引领性差异化
      {
        over: {
          desc: ['围绕场景数字化', '实现更高水平的价值分享'],
          bg: require(`@/assets/baas/ld-bg3.png`)
        },
        leave: {
          icon: 'icon-fenxiang1',
          title: '价值分享',
          bg: require(`@/assets/baas/ld-bg0.png`)
        }
      },
      {
        over: {
          desc: ['围绕卡奥斯引擎', '实现更深程度的价值创造'],
          bg: require(`@/assets/baas/ld-bg4.png`)
        },
        leave: {
          icon: 'icon-wendangxiugai',
          title: '价值创造',
          bg: require(`@/assets/baas/ld-bg1.png`)
        }
      },
      {
        over: {
          desc: ['围绕实时流数据', '实现更广范围的价值传递'],
          bg: require(`@/assets/baas/ld-bg5.png`)
        },
        leave: {
          icon: 'icon-wangzhi_huaban',
          title: '价值传递',
          bg: require(`@/assets/baas/ld-bg2.png`)
        }
      }
    ],
    CoreValue: [ // 核心价值
      [
        {
          icon: require('@/assets/baas/core-icon0.png'),
          title: '卡奥斯D3OS数字孪生平台',
          desc: '是卡奥斯为工业企业数智化转型打造的数据智能和数字孪生端到端解决方案。',
          isRecommend: false,
          url: 'https://www.cosmoplat.com/activity/d3os',
          isBtn: false
        },
        {
          icon: require('@/assets/baas/core-icon1.png'),
          title: 'KU易记',
          desc: '一款微应用，管理中小企业在制品，1分钟上手操作，10分钟就能感受到数字化带来的效果。',
          isRecommend: true,
          url: 'https://www.cosmoplat.com/choice?solutionId=1595312907104034817',
          isBtn: false
        },
        {
          icon: require('@/assets/baas/core-icon2.png'),
          title: '轻量化数字孪生',
          desc: '以低代码为核心，融合多系统数据，打通多系统应用，为企业构建轻松易上手的工具平台',
          isRecommend: false,
          url: 'https://www.cosmoplat.com/choice?solutionId=1442728603946983425',
          isBtn: false
        },
        {
          icon: require('@/assets/baas/core-icon3.png'),
          title: '双碳场景',
          desc: '通过打造全场景碳追溯可视化管理，为客户提供切实可行的双碳解决方案，让每个生产企业都有可行的路径来实现深度减排，并处理现有资产，有序转型。',
          isRecommend: true,
          url: 'https://www.cosmoplat.com/choice?solutionId=1428535173024030722',
          isBtn: false
        },
        {
          icon: require('@/assets/baas/core-icon4.png'),
          title: '天马低代码平台',
          desc: '企业应用开发首选工具，成就每一位工业知识工作者。',
          isRecommend: false,
          url: 'https://www.cosmoplat.com/choice?solutionId=1549236594053566465',
          isBtn: false
        },
        {
          icon: require('@/assets/baas/core-icon5.png'),
          title: '化工园区智慧运营',
          desc: '提升监管能力、服务能力和化工园区竞争力。',
          isRecommend: true,
          url: 'https://www.cosmoplat.com/choice?solutionId=1414783738193092610',
          isBtn: false
        },
        {
          icon: require('@/assets/baas/core-icon6.png'),
          title: '工控机解决方案',
          desc: '依托云平台+大数据增值服务，通过数据分析精准消费者画像，为厂商的产品迭代、精准营销、运营决策提供多维度市场数据。',
          isRecommend: true,
          url: 'https://www.cosmoplat.com/choice?solutionId=1582258711517044737',
          isBtn: false
        },
        {
          icon: require('@/assets/baas/core-icon7.png'),
          title: '青岛市工业互联网企业综合服务平台',
          desc: '以卡奥斯COSMOPlat工业互联网平台BaaS引擎为基础，是全国首个赋能企业全生命周期的生态平台。',
          isRecommend: false,
          url: 'https://www.cosmoplat.com/choice?solutionId=1425693118375944194',
          isBtn: false
        }
      ],
      [
        {
          icon: require('@/assets/baas/core-icon6.png'),
          title: '工控机解决方案',
          desc: '依托云平台+大数据增值服务，通过数据分析精准消费者画像，为厂商的产品迭代、精准营销、运营决策提供多维度市场数据。',
          isRecommend: true,
          url: 'https://www.cosmoplat.com/choice?solutionId=1582258711517044737',
          isBtn: false
        },
        {
          icon: require('@/assets/baas/core-icon9.png'),
          title: '海智造云平台',
          desc: '制造全流程数字化专家，懂制造，更智能。',
          isRecommend: false,
          url: 'https://im-portal.s.cosmoplat.com/',
          isBtn: false
        },
        {
          icon: require('@/assets/baas/core-icon10.png'),
          title: '家电智能控制解决方案',
          desc: '面向家电行业，为企业提供从设计、研发、采购、制造等全流程的智能控制器产品服务。',
          isRecommend: false,
          url: 'https://www.cosmoplat.com/choice?solutionId=1415603146759053314',
          isBtn: false
        },
        {
          icon: require('@/assets/baas/core-icon11.png'),
          title: '天链（区块链平台）',
          desc: '致力于打造全球领先的企业级区块链技术服务平台，为企业客户及开发者提供高效、安全、弹性、开箱即用的区块链服务。',
          isRecommend: false,
          url: 'https://cbs.cosmoplat.com/',
          isBtn: false
        },
        {
          icon: require('@/assets/baas/core-icon7.png'),
          title: '青岛市工业互联网企业综合服务平台',
          desc: '以卡奥斯COSMOPlat工业互联网平台BaaS引擎为基础，是全国首个赋能企业全生命周期的生态平台。',
          isRecommend: false,
          url: 'https://www.cosmoplat.com/choice?solutionId=1425693118375944194',
          isBtn: false
        },
        {
          icon: require('@/assets/baas/core-icon13.png'),
          title: '模具物联智能管理',
          desc: '通过平台+智能终端的形式，对模具进行全生命周期管理，个性化适应企业需求，通过设备反馈的数据指导企业经营决策。',
          isRecommend: true,
          url: 'https://www.cosmoplat.com/choice?solutionId=1412304727739179010',
          isBtn: false
        },
        {
          icon: require('@/assets/baas/core-icon14.png'),
          title: '离散制造设备智慧物联方案',
          desc: '由设备物联平台，通过智能采控终端，可实现在线监控、实时预警、设备排产、无感报工、质量检测分析等功能需求。',
          isRecommend: true,
          url: 'https://www.cosmoplat.com/choice?solutionId=1414867095102922754',
          isBtn: false
        },
        {
          icon: require('@/assets/baas/core-icon15.png'),
          title: '天玑（机理模型）',
          desc: '覆盖工业机理模型的全流程管理，包括模型审批，模型上架，模型展示，模型交易，等众多业务环节。',
          isRecommend: false,
          url: 'https://imm.cosmoplat.com/',
          isBtn: false
        }
      ]
    ],
    empowerment: [ // BaaS引擎赋能力
      {
        title: '个性化定制',
        desc: '从产品交付到需求交互',
        icon: '',
        isActive: true,
        children: [
          {
            title: '工业APP开源社区',
            desc: ['低代码平台', 'PaaS平台', 'Server less平台'],
            icon: ''
          },
          {
            title: '柔性化设计',
            desc: ['柔性化排产', '柔性化生产', '柔性化供应链'],
            icon: ''
          },
          {
            title: '大规模定制套件',
            desc: ['生产制造APP', '运维服务APP', '经营管理APP'],
            icon: ''
          }
        ]
      },
      {
        title: '平台化设计',
        desc: '从串联设计到并行设计',
        icon: '',
        isActive: false,
        children: [
          {
            title: '并行设计',
            desc: ['并行过程建模', '云CAD/CAE', '集成产品模型'],
            icon: ''
          },
          {
            title: '虚拟化仿真',
            desc: ['虚拟制造', '虚拟设计', '虚拟装配'],
            icon: ''
          },
          {
            title: '交互设计',
            desc: ['图形化设计', '轻量化设计', '敏捷设计'],
            icon: ''
          }
        ]
      },
      {
        title: '智能化制造',
        desc: '从自动化到智能化',
        icon: '',
        isActive: false,
        children: [
          {
            title: '智能设备',
            desc: ['设备状态监测', '设备故障诊断', '预测性维护'],
            icon: ''
          },
          {
            title: '智能车间',
            desc: ['智能产品设计', '智能生产制造', '智能产线监测'],
            icon: ''
          },
          {
            title: '智能服务',
            desc: ['供应链风险管理', '产品质量检测', '智慧物流'],
            icon: ''
          }
        ]
      },
      {
        title: '网络化协同',
        desc: '从功能性到智能型',
        icon: '',
        isActive: false,
        children: [
          {
            title: '协同设计',
            desc: ['基于模型的MBD', '集成研发流程IPD'],
            icon: ''
          },
          {
            title: '协同生产',
            desc: ['云制造', '云排产', '共享制造'],
            icon: ''
          },
          {
            title: '协同服务',
            desc: ['人员和设备协同', '运维知识协同'],
            icon: ''
          }
        ]
      },
      {
        title: '服务化延伸',
        desc: '从生产型到服务型',
        icon: '',
        isActive: false,
        children: [
          {
            title: '无工厂生产系统',
            desc: ['创新研发管理', '产业链协同管理', '生产运营管理'],
            icon: ''
          },
          {
            title: '产品集成系统',
            desc: ['个性化产品设计', '一体化成套安装', '集成化运营维护'],
            icon: ''
          },
          {
            title: '产品服务系统',
            desc: ['实时化在线支持', '精准化预测维护', '多元化租售模式'],
            icon: ''
          }
        ]
      },
      {
        title: '数字化管理',
        desc: '从线性管理到非线管理',
        icon: '',
        isActive: false,
        children: [
          {
            title: '管理在线',
            desc: ['网络化组织', '信息化日清'],
            icon: ''
          },
          {
            title: '业务在线',
            desc: ['线上线下一体', '全渠道营销'],
            icon: ''
          },
          {
            title: '产品在线',
            desc: ['交互定制', '全生命周期PLM'],
            icon: ''
          },
          {
            title: '用户在线',
            desc: ['用户感知系统', '用户服务系统'],
            icon: ''
          }
        ]
      }
    ],
    BottomCard: [
      {
        title: '连接力',
        icon: 'icon-shengtaiquan'
      },
      {
        title: '数据力',
        icon: 'icon-shujuwajue'
      },
      {
        title: '仿真力',
        icon: 'icon-fangzhen'
      },
      {
        title: '定制力',
        icon: 'icon-dingzhi'
      },
      {
        title: '开源力',
        icon: 'icon-kaiyuan'
      },
      {
        title: '安全力',
        icon: 'icon-anquan'
      }
    ]
  },
  BigData: {
    poList: [ // 平台能力
      {
        img: require('@/assets/big-data/bd-po0.png'),
        pre: '数据“',
        center: '大体量',
        next: '”汇聚能力'
      },
      {
        img: require('@/assets/big-data/bd-po1.png'),
        pre: '数据“',
        center: '多样性',
        next: '”处理能力'
      },
      {
        img: require('@/assets/big-data/bd-po2.png'),
        pre: '数据“',
        center: '高价值',
        next: '”转化能力'
      },
      {
        img: require('@/assets/big-data/bd-po3.png'),
        pre: '数据“',
        center: '高质量',
        next: '”治理能力'
      }
    ],
    fcmList: [// 核心功能模块
      {
        over: {
          title: '数据集成',
          desc: '实现多源异构数据高效入湖，支持批/流/实时数据多种方式接入，快速实现企业应用所需的数据铺底',
          bg: require(`@/assets/big-data/fcm-bg.png`)
        },
        leave: {
          title: '数据集成',
          img: require('@/assets/big-data/fcm0.png')
        }
      },
      {
        over: {
          title: '作业管理',
          desc: '提供可视化数据开发平台，丰富的数据开发组件，全自动的作业调度和监控能力，降低了用户使用大数据的门槛，帮助用户快速实现数据加工与处理',
          bg: require(`@/assets/big-data/fcm-bg.png`)
        },
        leave: {
          title: '作业管理',
          img: require('@/assets/big-data/fcm1.png')
        }
      },
      {
        over: {
          title: '数据服务',
          desc: 'API接口形式对业务提供服务，支持数据服务的全生命周期管理，实现数据共享，将有价值的数据合理、合规、安全、高效的提供给各业务线的数据需求方',
          bg: require(`@/assets/big-data/fcm-bg.png`)
        },
        leave: {
          title: '数据服务',
          img: require('@/assets/big-data/fcm2.png')
        }
      },
      {
        over: {
          title: '数据治理',
          desc: '通过对数据从创建到消亡的全过程的监控和治理，实现数据的统一管理，为企业保证了业务数据在采集、集中、转换、存储、应用整个过程中的完整性、准确性、一致性和时效性',
          bg: require(`@/assets/big-data/fcm-bg.png`)
        },
        leave: {
          title: '数据治理',
          img: require('@/assets/big-data/fcm3.png')
        }
      }
    ],
    pfList: [// 产品特色
      {
        over: {
          title: '全场景',
          desc: '数据集成、数据管理、数据开发、数据分析应用、数据服务一站完成'
        },
        leave: {
          title: '全场景',
          img: require('@/assets/big-data/pf0.png')
        }
      },
      {
        over: {
          title: '低门槛',
          desc: '拖拽式零代码数据集成，数据作业可视化开发、编排和调度，多源即席联合分析'
        },
        leave: {
          title: '低门槛',
          img: require('@/assets/big-data/pf1.png')
        }
      },
      {
        over: {
          title: '统一服务',
          desc: '基于API对外提供数据服务能力，可对下游应用屏蔽数据源细节'
        },
        leave: {
          title: '统一服务',
          img: require('@/assets/big-data/pf2.png')
        }
      }
    ]
  },
  Blockchain: {
    feature: [
      {
        img: require('@/assets/blockchain/feature0.png'),
        title: '安全性',
        desc: '支持国内主流的密码机、全模块、全流程支持国密，协同构筑国密安全体系'
      },
      {
        img: require('@/assets/blockchain/feature1.png'),
        title: '国产化',
        desc: '与国产处理器平台，多款国产操作系统等完成了兼容性互认，完全适配国产化软硬件环境'
      },
      {
        img: require('@/assets/blockchain/feature2.png'),
        title: '高性能',
        desc: '高效并行调度算法、高性能合约执行引擎、流水线共识算法等技术，交易可达10万TPS，位居全球领先水平'
      },
      {
        img: require('@/assets/blockchain/feature3.png'),
        title: '易开发',
        desc: '支持多种智能合约开发语言，包括Rust、Go、C++和Solidity等'
      }, {
        img: require('@/assets/blockchain/feature4.png'),
        title: '配套工具',
        desc: '丰富的配套工具CA管理，证书管理，合约管理，区块链浏览器，跨链配置，隐私计算，硬件加密，运维监控'
      }
    ],
    ability: [
      {
        title: '联盟管理',
        desc: '展示用户创建的或者加入的联盟详细信息，支持用户新建联盟，邀请成员加入联盟等操作'
      },
      {
        title: '事件中心',
        desc: '用户可在此进行事件查看与投票，与链相关的事件包括邀请加入联盟、邀请加入网络、申请新增共识节点'
      },
      {
        title: '区块链网络',
        desc: '目前1个网络即为1条链。“区块链网络”页面展示用户创建的或者加入的区块链网络信息'
      },
      {
        title: '合约管理',
        desc: '可将合约安装到链上，或对合约做升级、废止操作。合约文件为.wasm格式，支持 C++、go、rust 等3个执行环境'
      },
      {
        title: '节点管理',
        desc: '展示本组织所拥有的节点的基本信息、状态、监控指标、日志等，支持添加节点、扩容磁盘、调整节点配置等操作'
      },
      {
        title: '证书管理',
        desc: '在此可申请及下载链相关的证书，包括：组织根证书、用户证书、节点 TLS 证书'
      }
    ],
    productInfo: [
      {
        title: '产品定位',
        desc: '卡奥斯区块服务CBS，是一个企业级的区块链开放平台，可一键式快速部署接入、拥有去中心化信任机制、支持多组织资源分配模式，拥有私有化部署与网络运维管理能力'
      },
      {
        title: '产品价值',
        desc: '构建可信，安全的数据流通环境，只有数据可信，才能进行后续的价值挖掘，不可信的数据没有价值，通过区块链这一技术手段构建的信任会更加客观、稳定，从而让更多参与方能够放心地参与合作'
      }
    ],
    AppScenario: [
      {
        title: '供应链金融',
        img: require('@/assets/blockchain/app-scenario1.png')
      },
      {
        title: '电子票据',
        img: require('@/assets/blockchain/app-scenario2.png')
      },
      {
        title: '电子存证',
        img: require('@/assets/blockchain/app-scenario3.png')
      },
      {
        title: '信用管理',
        img: require('@/assets/blockchain/app-scenario4.png')
      },
      {
        title: '电子证照',
        img: require('@/assets/blockchain/app-scenario5.png')
      },
      {
        title: '跨境贸易',
        img: require('@/assets/blockchain/app-scenario6.png')
      },
      {
        title: '数据交换',
        img: require('@/assets/blockchain/app-scenario7.png')
      }
    ]
  },
  MechanismModel: {
    Platform: [
      {
        title: '机理模型综合管理平台',
        desc: '为工业机理模型提供创建、审核、上架、消息等服务，并于其他模块互联互通，共同完成工业机理模型的管理。',
        img: require(`@/assets/mechanism-model/imm0.png`)
      },
      {
        title: '机理模型集成开发平台',
        desc: '为开发者提供统一、便捷的机理模型开发环境，具备广泛的模型服务封装能力。',
        img: require(`@/assets/mechanism-model/imm1.png`)
      },
      {
        title: '机理模型仿真开发平台',
        desc: '为用户提供一个全方位了解设备产品全生命周期的虚拟平台，让用户在数字世界里切实体验到智能制造的核心价值。',
        img: require(`@/assets/mechanism-model/imm2.png`)
      },
      {
        title: '机理模型库',
        desc: '包含模型入库存储、模型部署、模型下载、模型删除、模型浏览等业务模块。',
        img: require(`@/assets/mechanism-model/imm3.png`)
      }
    ],
    feature: [
      {
        img: require('@/assets/mechanism-model/feature0.png'),
        title: '模板多样',
        desc: '内置监控模版，自动创建模型监控全套报表；支持报表自定义'
      },
      {
        img: require('@/assets/mechanism-model/feature1.png'),
        title: '功能丰富',
        desc: '建模功能丰富，可视化建模算子多，编码建模专业度高'
      },
      {
        img: require('@/assets/mechanism-model/feature2.png'),
        title: '部署灵活',
        desc: '部署方式灵活，对客户环境无依赖，扩展性强、支持定制化开发'
      }
    ],
    industrialModel: [
      {
        title: '数据算法模型',
        num1: '27',
        num2: '324,704'
      },
      {
        title: '研发仿真模型',
        num1: '13',
        num2: '55,790'
      },
      {
        title: '行业机理模型',
        num1: '15',
        num2: '940,434'
      },
      {
        title: '业务流程模型',
        num1: '21',
        num2: '159,083'
      }
    ],
    ProductAbility: [
      {
        title: '研发设计仿真',
        desc: '通过研发仿真模型中封装的算法，可以对真实世界的信息进行处理，进行参数的模拟、物质流及能量流的算法运算输出，从而将物理设备以及业务流程运作的实际情况以数字化的形式呈现，掌握实时动态，进行诊断和处理'
      },
      {
        title: '生产过程管理',
        desc: '将实际工业流程生产过程在数字世界的模拟可视化，通过将生产流程进行建模，结合工业大数据平台进行分析，实现对工业生产过程的全方位态势感知，实现效率提升'
      },
      {
        title: '设备故障诊断',
        desc: '通过提取并分析设备故障时的特征信号，结合机器设备运维经验，将种故障的位置、类型、性质、原因、趋势等进行了细分，形成设备故障诊断和维修的知识图谱，结合大数据分析，实时调整针对各类故障的解决方案的推荐顺序，提升设备运维的效率'
      },
      {
        title: '产品质量控制',
        desc: '通过将企业生产过程形成的质量管理体系进行封装，从而使质量控制的知识和经验得以固化，赋能企业的生产绩效提升'
      }
    ]
  },
  IntelligentVision: {
    coreProducts: [
      {
        over: {
          title: '火焰检测',
          bg: require(`@/assets/intelligent-vision/iv-cp-o.png`),
          // btn: true,
          btnurl: 'http://baas-model.hdt.cosmoplat.com/#/dashboard/1/calling'
        },
        leave: {
          title: '火焰检测',
          desc: ['项目描述：识别图片中的火焰', '项目检测目标：火焰'],
          bg: require(`@/assets/intelligent-vision/iv-cp-l.png`)
        }
      },
      {
        over: {
          title: '口罩识别',
          bg: require(`@/assets/intelligent-vision/iv-cp-o.png`),
          // btn: true,
          btnurl: 'http://baas-model.hdt.cosmoplat.com/#/dashboard/2/calling'
        },
        leave: {
          title: '口罩识别',
          desc: ['项目描述：检测图片或者视频中行人是否佩戴口罩或者佩戴不规范等行为', '项目检测目标：口罩'],
          bg: require(`@/assets/intelligent-vision/iv-cp-l.png`)
        }
      },
      {
        over: {
          title: '划痕检测',
          bg: require(`@/assets/intelligent-vision/iv-cp-o.png`),
          // btn: true,
          btnurl: 'http://baas-model.hdt.cosmoplat.com/#/dashboard/3/calling'
        },
        leave: {
          title: '划痕检测',
          desc: ['项目描述：表面划痕检测', '项目检测目标：划痕'],
          bg: require(`@/assets/intelligent-vision/iv-cp-l.png`)
        }
      },
      {
        over: {
          title: '人流密度检测',
          bg: require(`@/assets/intelligent-vision/iv-cp-o.png`),
          // btn: true,
          btnurl: 'http://baas-model.hdt.cosmoplat.com/#/dashboard/4/calling'
        },
        leave: {
          title: '人流密度检测',
          desc: ['项目描述：检测图片或者视频中人流密度进一步确认是否超过最大限流', '项目检测目标：人'],
          bg: require(`@/assets/intelligent-vision/iv-cp-l.png`)
        }
      },
      {
        over: {
          title: '行人检测算法模型',
          bg: require(`@/assets/intelligent-vision/iv-cp-o.png`),
          // btn: true,
          btnurl: 'http://baas-model.hdt.cosmoplat.com/#/dashboard/5/calling'
        },
        leave: {
          title: '行人检测算法模型',
          desc: ['项目描述：检测图片或者视频中的行人检测', '项目检测目标：行人'],
          bg: require(`@/assets/intelligent-vision/iv-cp-l.png`)
        }
      },
      {
        over: {
          title: '烟火识别检测算法模型',
          bg: require(`@/assets/intelligent-vision/iv-cp-o.png`),
          // btn: true,
          btnurl: 'http://baas-model.hdt.cosmoplat.com/#/dashboard/6/calling'
        },
        leave: {
          title: '烟火识别检测算法模型',
          desc: ['项目描述：识别工厂或者园区中，烟火安全隐患，对于安全监管和提前预警有重要作用', '项目检测目标： 烟火'],
          bg: require(`@/assets/intelligent-vision/iv-cp-l.png`)
        }
      }
    ],
    applicationScenario: [
      {
        over: {
          title: '公共安全',
          bg: require(`@/assets/intelligent-vision/as00.png`)
        },
        leave: {
          title: '公共安全',
          bg: require(`@/assets/intelligent-vision/as0.png`)
        }
      },
      {
        over: {
          title: '智能工厂',
          bg: require(`@/assets/intelligent-vision/as11.png`)
        },
        leave: {
          title: '智能工厂',
          bg: require(`@/assets/intelligent-vision/as1.png`)
        }
      },
      {
        over: {
          title: '智慧交通',
          bg: require(`@/assets/intelligent-vision/as22.png`)
        },
        leave: {
          title: '智慧交通',
          bg: require(`@/assets/intelligent-vision/as2.png`)
        }
      }
    ]
  },
  Lcode: {
    productValue: [
      {
        img: require('@/assets/lcode/pv0.png'),
        title: '降低企业成本',
        desc: '平台提供可视化开发环境，简单拖拽实现应用搭建，上手快、学习门槛低，可让更多企业投入到开发中'
      },
      {
        img: require('@/assets/lcode/pv1.png'),
        title: '帮助企业实现敏捷开发',
        desc: '平台基于模型驱动构建界面呈现，使用逻辑可视化的编辑方式，有助于提升开发效率，业务灵感快速投入生产验证，助力企业创新。'
      },
      {
        img: require('@/assets/lcode/pv2.png'),
        title: '实现数字化转型升级',
        desc: '平台的应用、页面、基础组件、扩展组件、接口等不同粒度的软件资产，均支持灵活复用。'
      },
      {
        img: require('@/assets/lcode/pv3.png'),
        title: '解决数据和信息孤岛的矛盾',
        desc: '平台支持一键发布，快速交付精简的解决方案，实现软件生产过程标准化、流程化，助力企业用户聚焦于业务开发，实现业务增长。'
      }
    ],
    platformFeatures: [
      {
        img: require('@/assets/lcode/pf0.png'),
        title: '多租户隔离',
        desc: '多租户模式，为工业应用提供集团型、多机构、多租户支持，轻松实现集中管控、灵活使用。'
      },
      {
        img: require('@/assets/lcode/pf1.png'),
        title: '多应用隔离',
        desc: '支持各类应用的隔离、定制和运维，轻松实现组织内外业务系统的统一规划、集中或分布部署、即时发布、灵活定制。'
      },
      {
        img: require('@/assets/lcode/pf2.png'),
        title: '弹性部署',
        desc: '提供共有云、私有云环境下各种方式的弹性部署方式，支持资源的自动化智能调度，最大限度利用资源。'
      },
      {
        img: require('@/assets/lcode/pf3.png'),
        title: '组件可扩展',
        desc: '可预置常见的工业标准组件，也可定制开发、扩展新组件，简单通过拖拽组件即可设计出所需表单页面。'
      }
    ],
    applicationScenario: [
      {
        img: require('@/assets/lcode/as0.png'),
        title: '业务人员',
        desc: '业务表单自定义，主力业务开展'
      },
      {
        img: require('@/assets/lcode/as1.png'),
        title: 'IT开发者',
        desc: '快速开发高阶应用；可自主开发组件，增强平台能力'
      },
      {
        img: require('@/assets/lcode/as2.png'),
        title: '运营人员',
        desc: '搭建管理流程系统，优化运营效果'
      },
      {
        img: require('@/assets/lcode/as3.png'),
        title: '管理者',
        desc: '协调资源配置，创新管理模式'
      }
    ]
  },
  BI: {
    PlatformCapability: [
      {
        img: require('@/assets/bi/pc0.png'),
        title: '数据获取',
        desc: '数据接入层接入企业中高质量低成本的数据，并将数据进行整合，建立企业数据仓库'
      },
      {
        img: require('@/assets/bi/pc1.png'),
        title: '数据分析',
        desc: '对数据仓库的数据进行挖掘，提供可视化分析、多维交互分析、可视化编排等数据分析工具，实现数据的智能分析'
      },
      {
        img: require('@/assets/bi/pc2.png'),
        title: '数据展示',
        desc: '将分析的数据通过可视化的图表等形式，通过移动端、PC端、大屏端等方式及时呈现给用户'
      }
    ],
    coreFunctions: [
      {
        img: require('@/assets/bi/cf0.png'),
        title: '多数据源',
        desc: '支持直连MySQL、Oracle、Hive、Spark、Kylin、Doris、InfluxDB、Prometheus、Cassandra、Redis、Mongo、ES、File、API等数据源'
      },
      {
        img: require('@/assets/bi/cf1.png'),
        title: '图表丰富',
        desc: '提供海量可视化图表及多种过滤组件，支持自定义图表效果，充分满足多样化的可视化需求'
      },
      {
        img: require('@/assets/bi/cf2.png'),
        title: '零代码搭建',
        desc: '使用可视化编辑器，所见即所得，拖拽生成可视化页面，轻松编辑不写代码'
      },
      {
        img: require('@/assets/bi/cf3.png'),
        title: '数据大屏',
        desc: '将BI报表和大屏功能融合，提供多套大屏模板，实时呈现业务数据，满足大型会议、领导参观、展览、业务监控等需求'
      },
      {
        img: require('@/assets/bi/cf4.png'),
        title: '交互分析',
        desc: '报表与大屏均支持过滤、下钻、联动、跨屏传参等灵活交互，轻松对数据进行深度分析挖掘'
      },
      {
        img: require('@/assets/bi/cf5.png'),
        title: '多端使用',
        desc: '完美适配PC、移动应用、展示大屏，支持多屏幕的数据展示，PC端设计即可多终端展示'
      }
    ],
    swiper: [
      {
        bg: require('@/assets/bi/as0.png'),
        title: '数据查询',
        desc: 'BI多维分析工具可以实现即时查询、多维度定义等应用场景。'
      },
      {
        bg: require('@/assets/bi/as1.png'),
        title: '数据可视化',
        desc: '数据可视化的本质就是视觉对话，数据可视化将数据分析技术与图形技术结合，可以帮助用户更好地理解数据信息，挖掘数据价值。'
      },
      {
        bg: require('@/assets/bi/as2.png'),
        title: '数据大屏',
        desc: '数据大屏中的内容被称为管理驾驶舱，为管理者提供的一站式决策支持的管理信息中心系统。'
      },
      {
        bg: require('@/assets/bi/as3.png'),
        title: '移动应用',
        desc: 'BI在移动端上的功能和PC端相比有所扩展，除了常规的数据分析外，还有消息推送、手机扫码、应用集成等。'
      },
      {
        bg: require('@/assets/bi/as4.png'),
        title: '自助分析',
        desc: 'BI自助分析模式可以使IT主导的报表模式转变为业务主导的自助式分析模型，从而减少数据建设到决策分析的时间，赋能业务，提高效率。'
      }
    ]
  }
}
export default dic
